import React from "react";
import { Link } from "react-router-dom";
import logo from "../Images/CTF LOGO 2.png";
import reviewQR from "../Images/MY_QR.jpeg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__grid">
          <div className="footer__brand">
            <img src={logo} alt="CTF Logo" className="footer__logo" width="482" height="518" loading="lazy" decoding="async" />
            <p className="footer__desc">
              Computer Technology Foundation helps learners build strong fundamentals,
              practical skills, and confident careers in technology.
            </p>
            <div className="footer__social">
              <span className="footer__heading">Follow us</span>
              <div className="footer__social-icons">
                <a href="https://www.facebook.com/ctfglobal" target="_blank" rel="noreferrer" className="footer__social-icon" aria-label="Facebook">
                  <i className="fab fa-facebook-f" />
                </a>
                <a href="https://www.instagram.com/ctf_global" target="_blank" rel="noreferrer" className="footer__social-icon" aria-label="Instagram">
                  <i className="fab fa-instagram" />
                </a>
                <a href="https://wa.me/919898233038" target="_blank" rel="noreferrer" className="footer__social-icon" aria-label="WhatsApp">
                  <i className="fab fa-whatsapp" />
                </a>
              </div>
            </div>
          </div>

          <div className="footer__block">
            <h6 className="footer__heading">Quick Links</h6>
            <ul className="footer__list">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/all-courses">Course</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer__block">
            <h6 className="footer__heading">Programs</h6>
            <ul className="footer__list">
              <li><Link to="/ctf_courses">CTF Courses</Link></li>
              <li><Link to="/university">University</Link></li>
              <li><Link to="/mauritius">Mauritius</Link></li>
              <li><Link to="/internships">Internships</Link></li>
            </ul>
          </div>

          <div className="footer__block">
            <h6 className="footer__heading">Contact</h6>
            <p className="footer__line">
              <span className="footer__label">Email:</span> 
              <ul>
                <li>ctfindia@gmail.com </li>
                <li>contact@ctfglobal.in</li>
              </ul>
            </p>
            <p className="footer__line">
              <span className="footer__label">Phone:</span> 
              <ul>
                <li>+91 98982 33038</li>
                <li>+91 92277 78181</li>
              </ul>
            </p>
            <p className="footer__line footer__address">
              <span className="footer__label">Address:</span>
              B-Block, First Floor, Mangaltirth Complex, Nr. Dharnidhar Over Bridge, Ahmedabad – 380007
            </p>
          </div>

          <div className="footer__block footer__feedback">
            <h6 className="footer__heading">Feedback</h6>
            <div className="footer__qr-wrap">
              <img
                src={reviewQR}
                alt="Review QR Code"
                className="footer__qr"
                width="800"
                height="800"
                loading="lazy"
                decoding="async"
                style={{ border: "5px solid #fff" }}
              />
              <p className="footer__qr-caption">Scan the QR code to share your experience and leave a quick review.</p>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <span>© {currentYear} Computer Technology Foundation. All rights reserved.</span>
          <span className="footer__meta">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <span aria-hidden="true"> · </span>
            Made with care for learners across India &amp; beyond.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
